import { render } from "./DeclencheurStatusCommand.vue?vue&type=template&id=2904ce70"
import script from "./DeclencheurStatusCommand.vue?vue&type=script&lang=ts"
export * from "./DeclencheurStatusCommand.vue?vue&type=script&lang=ts"
script.render = render

export default script